import type { ApmBase } from '@elastic/apm-rum';

// Holds the agent once init.ts has started it. Kept free of SDK imports so pages can set
// identifiers (ids.ts) without pulling @elastic/apm-rum into their bundle.
type Op = (apm: ApmBase) => void;

let agent: ApmBase | undefined;
const pending: Op[] = [];
// Calls made before the agent loads (or on hosts where it never starts) stay bounded.
const MAX_PENDING = 50;

const run = (apm: ApmBase, op: Op) => {
  try {
    op(apm);
  } catch {
    // Monitoring must never break the page.
  }
};

export function setRumAgent(apm: ApmBase) {
  agent = apm;
  pending.splice(0).forEach(op => run(apm, op));
}

/** The running agent, or undefined before init.ts has started it (or where it never starts). */
export function getRumAgent(): ApmBase | undefined {
  return agent;
}

/** Runs now if the agent is up, otherwise once it starts (dropped if it never does). */
export function withRum(op: Op) {
  if (agent) run(agent, op);
  else if (pending.length < MAX_PENDING) pending.push(op);
}
